export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/893f408264c7f48708f4fd5a72a9bdbf.png"
          alt="Professional landscaping service"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Year-Round Landscaping
            <br />
            <span className="text-yellow-400">& Snow Removal</span>
          </h2>
          <p className="text-xl sm:text-2xl text-white/95 mb-8 max-w-3xl mx-auto font-light">
            Everything handled for one flat monthly rate – Greater Toronto Area
          </p>
          <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto">
            Professional maintenance & construction services with no surprises, no extra charges
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <button
              onClick={scrollToContact}
              className="px-8 py-4 bg-yellow-400 text-gray-900 text-lg font-bold rounded-full hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-file-text-line mr-2 text-xl"></i>
              Request Quote
            </button>
            <a
              href="tel:+16479837924"
              className="px-8 py-4 bg-white text-gray-900 text-lg font-bold rounded-full hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Call (647) 983-7924
            </a>
            <a
              href="https://www.instagram.com/mowandsnowco?igsh=MWFodGJvdzdmenVtOA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-lg font-bold rounded-full hover:from-purple-700 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-instagram-line mr-2 text-xl"></i>
              View Our Work
            </a>
          </div>

          {/* Trust Badges */}
          <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/90">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-2xl text-green-400"></i>
              <span className="font-medium">Licensed & Insured</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-2xl text-cyan-400"></i>
              <span className="font-medium">Proudly Serving the GTA</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-star-fill text-2xl text-yellow-400"></i>
              <span className="font-medium">500+ Happy Clients</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}